import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import StatusCard from '../components/StatusCard';
import ControlModal from '../components/ControlModal';

export default function Dashboard() {
  const [showControl, setShowControl] = useState(null);
  const [tempValue, setTempValue] = useState(0);
  const [humidityValue, setHumidityValue] = useState(0);
  const [desiredTemp, setDesiredTemp] = useState(0);
  const [desiredHumidity, setDesiredHumidity] = useState(0);
  const [servoStatus, setServoStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchValues();
    const interval = setInterval(fetchValues, 2000);
    return () => clearInterval(interval);
  }, []);

  const fetchValues = () => {
    fetch('https://projecteggincubator.com/gettemp.php')
      .then(res => res.json())
      .then(data => {
        if (data.desiredTemp) setDesiredTemp(parseFloat(data.desiredTemp));
        if (data.currentTemp) setTempValue(parseFloat(data.currentTemp));
      });

    fetch('https://projecteggincubator.com/gethumidity.php')
      .then(res => res.json())
      .then(data => {
        if (data.desiredHumidity) setDesiredHumidity(parseFloat(data.desiredHumidity));
        if (data.currentHumidity) setHumidityValue(parseFloat(data.currentHumidity));
      });

    fetch('https://projecteggincubator.com/get-servo-status.php')
      .then(res => res.text())
      .then(status => {
        setServoStatus(status.trim() === 'on');
      });
  };

  const handleConfirm = (newValue) => {
    if (showControl === 'temp') {
      setDesiredTemp(newValue);
      fetch(`https://projecteggincubator.com/changetemp.php?desired=${newValue.toFixed(1)}`);
    } else if (showControl === 'humidity') {
      setDesiredHumidity(newValue);
      fetch(`https://projecteggincubator.com/changeHumidity.php?desired=${newValue.toFixed(1)}`);
    }
    setShowControl(null);
  };

  const toggleServo = () => {
    if (loading) return;
    setLoading(true);
    const newStatus = servoStatus ? 'off' : 'on';
    fetch(`https://projecteggincubator.com/update-servo-status.php?status=${newStatus}`)
      .then(res => res.text())
      .then(() => {
        setServoStatus(!servoStatus);
      })
      .finally(() => setLoading(false));
  };

  const renderCircle = (value, color) => {
    const radius = 60;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;

    return (
      <svg width="150" height="150" style={{ transform: 'rotate(-90deg)' }}>
        <circle
          r={radius}
          cx="75"
          cy="75"
          strokeWidth="10"
          fill="transparent"
          stroke={color}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
    );
  };

  return (
    <div className="page dashboard" style={{ backgroundColor: '#FEE191', height: '100vh', padding: 0 }}>
      <Header />
      <div style={{ marginTop: '1rem' }}>
        <StatusCard />
      </div>

      <div className="gauges" style={{ display: 'flex', justifyContent: 'center', gap: '4rem', marginTop: '2rem' }}>
        {/* Temperature Gauge */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{
            position: 'relative', width: 150, height: 150, borderRadius: '50%', backgroundColor: '#f5f5f5',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            {renderCircle(tempValue, '#ff5722')}
            <div style={{ position: 'absolute', fontSize: 28 }}>{tempValue.toFixed(1)}°C</div>
          </div>
          <div style={{ marginTop: '10px', fontSize: '18px' }}>🎯 เป้าหมาย: {desiredTemp.toFixed(1)}°C</div>
          <div onClick={() => setShowControl('temp')} style={{
            marginTop: '1rem', background: 'white', borderRadius: '12px', padding: '0.3rem 1rem',
            fontSize: '24px', cursor: 'pointer', border: '3px solid black'
          }}>
            ⚙️ ตั้งค่าอุณหภูมิ
          </div>
        </div>

        {/* Humidity Gauge */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{
            position: 'relative', width: 150, height: 150, borderRadius: '50%', backgroundColor: '#f5f5f5',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            {renderCircle(humidityValue, '#2196f3')}
            <div style={{ position: 'absolute', fontSize: 28 }}>{humidityValue.toFixed(1)}%</div>
          </div>
          <div style={{ marginTop: '10px', fontSize: '18px' }}>🎯 เป้าหมาย: {desiredHumidity.toFixed(1)}%</div>
          <div onClick={() => setShowControl('humidity')} style={{
            marginTop: '1rem', background: 'white', borderRadius: '12px', padding: '0.3rem 1rem',
            fontSize: '24px', cursor: 'pointer', border: '3px solid black'
          }}>
            ⚙️ ตั้งค่าความชื้น
          </div>
        </div>
      </div>

      {/* ปุ่มควบคุมเซอร์โว */}
      <div style={{ marginTop: '3rem', textAlign: 'center' }}>
        <button
          onClick={toggleServo}
          disabled={loading}
          style={{
            padding: '1rem 2.5rem',
            fontSize: '22px',
            backgroundColor: servoStatus ? '#e53935' : '#43a047',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
            opacity: loading ? 0.6 : 1
          }}
        >
          {servoStatus ? '🛑 ปิดเซอร์โว' : '▶️ เปิดเซอร์โว'}
        </button>
        <div style={{ marginTop: '1rem', fontSize: '18px' }}>
          สถานะเซอร์โว: {servoStatus ? '🟢 เปิดอยู่' : '🔴 ปิดอยู่'}
        </div>
      </div>

      {showControl && (
        <ControlModal
          type={showControl}
          value={showControl === 'temp' ? desiredTemp : desiredHumidity}
          onClose={() => setShowControl(null)}
          onConfirm={handleConfirm}
        />
      )}
    </div>
  );
}
